import React from 'react';
import styled from 'styled-components';

const StyledP = styled.p`
  width: 580px;
  line-height: 20px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledDiv = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 1.5em;
  line-height: 1.5;
  font-size: 12px;
`;

interface Props {
  value: any;
  isWide: boolean;
}

export const InquiryListItemMessage = (props: Props) => {
  const { value, isWide } = props;

  return isWide ? <StyledP>{value}</StyledP> : <StyledDiv>{value}</StyledDiv>;
};
